import local_settings, { FIELD_INSIGHTS_TYPES } from "../../../../lib/LocalSettings";
import { AVAILABLE_TYPES } from "../../../../lib/Insights";
import type { AvailableInsightTypes } from "../../../../lib/Insights";
import type { UpdateLineOrderComment } from "./linesOrders";
import { SET_INSIGHTS_ACTIONS_TYPES, SET_ORDER_TABLE_PRODUCTION_MODAL } from "./common";
import type { OrderTableProductionModal, SetInsightTypesActions, SetOrderTableProductionModalAction } from "./common";

export type AdvancedOrderMenuState = {
    order_uuid: string | null;
};

export type StandaloneGanttState = {
    insight_types: AvailableInsightTypes[];
    order_table_production_modal: OrderTableProductionModal;
};

export const getSelectedInsightTypes = (): AvailableInsightTypes[] => {
    const storage_insight_types = local_settings.getItem(FIELD_INSIGHTS_TYPES);
    if (storage_insight_types) return JSON.parse(storage_insight_types);

    return AVAILABLE_TYPES;
};

const order_table_production_modal_state = {
    show_modal: false,
    order_external_id: "",
    order_uuid: "",
    order_process_num: "",
};

const getInitialState = (): StandaloneGanttState => {
    const storage_insight_types = local_settings.getItem(FIELD_INSIGHTS_TYPES);
    if (storage_insight_types) {
        return {
            insight_types: JSON.parse(storage_insight_types),
            order_table_production_modal: order_table_production_modal_state,
        };
    }

    return {
        insight_types: AVAILABLE_TYPES,
        order_table_production_modal: order_table_production_modal_state,
    };
};

export type StandaloneGanttActions =
    | SetInsightTypesActions
    | SetOrderTableProductionModalAction
    | UpdateLineOrderComment;

export const standaloneGanttReducer = (
    state: StandaloneGanttState,
    action: StandaloneGanttActions
): StandaloneGanttState => {
    if (!state) {
        return getInitialState();
    }

    if (action.type === SET_INSIGHTS_ACTIONS_TYPES) {
        state.insight_types = action.data;
        local_settings.setItem(FIELD_INSIGHTS_TYPES, JSON.stringify(action.data));
        return { ...state };
    } else if (action.type === SET_ORDER_TABLE_PRODUCTION_MODAL) {
        state.order_table_production_modal = action.data;
        return { ...state };
    }

    return state;
};
